/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "internal": {
            "nested": {
              "message": {
                "nested": {
                  "SendDeviceCodePasswordRequest": {
                    "fields": {
                      "deviceCodeId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "emailAddress": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "phoneNumber": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "template": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "useMerchantEmail": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "SendDeviceCodePasswordResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.internal?.nested?.message?.nested?.SendDeviceCodePasswordRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.internal?.nested?.message?.nested?.SendDeviceCodePasswordResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SendDeviceCodePasswordRequest @ squareup/devicesettings/internal/message/send_device_code_password.proto at 13:1
 */
export const SendDeviceCodePasswordRequest = $root.lookupType('squareup.devicesettings.internal.message.SendDeviceCodePasswordRequest');
fixType(SendDeviceCodePasswordRequest, {
  deviceCodeId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SendDeviceCodePasswordRequest);
/**
 * SOURCE SendDeviceCodePasswordResponse @ squareup/devicesettings/internal/message/send_device_code_password.proto at 21:1
 */
export const SendDeviceCodePasswordResponse = $root.lookupType('squareup.devicesettings.internal.message.SendDeviceCodePasswordResponse');
fixType(SendDeviceCodePasswordResponse);
Builder.createAndAttachToType(SendDeviceCodePasswordResponse);